module.exports = __webpack_public_path__ + "img/ptptn.f2265f4c.png";